import { render, staticRenderFns } from "./Facilitator.vue?vue&type=template&id=51051240&scoped=true"
import script from "./Facilitator.vue?vue&type=script&lang=js"
export * from "./Facilitator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51051240",
  null
  
)

export default component.exports